import Image from 'next/image';
import Link from 'next/link';
import { getEdgeUrl } from '@/lib/getEdgeUrl';
import i18n from '@/settings/i18n';

const t = i18n.init('homepage');

const starryBg = getEdgeUrl(
  'images/homepage/banner/holidays/boxing-day/starry-bg.png',
);

const leftSection = getEdgeUrl(
  'images/homepage/banner/holidays/boxing-day/boxing-left-desktop-2025.png',
);
const rightSection = getEdgeUrl(
  'images/homepage/banner/holidays/boxing-day/right-desktop-2025.png',
);
const leftSectionMobile = getEdgeUrl(
  'images/homepage/banner/holidays/boxing-day/boxing-left-mobile-2025.png',
);
const rightSectionMobile = getEdgeUrl(
  'images/homepage/banner/holidays/boxing-day/mobile-right-2025.png',
);

const BoxingDayHero = () => (
  <Link
    href="/collections/hot-deals"
    prefetch
    className="relative flex h-full w-screen flex-col items-center justify-center overflow-hidden bg-[#020202] text-white"
  >
    {/* Starry Night Overlay */}
    <div className="absolute inset-0">
      <div className="h-[280px]">
        <Image
          src={starryBg}
          alt="Left Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto object-cover object-center"
          priority
        />
      </div>
    </div>
    {/* Left Block  */}
    <div className="absolute bottom-0 hidden md:left-[-200px] md:block lg:left-[-70px] xl:left-0">
      <div className="h-[280px]">
        <Image
          src={leftSection}
          alt="Left Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto"
          priority
        />
      </div>
    </div>
    {/* Right Block */}
    <div className="absolute top-0 hidden md:right-[-250px] md:block lg:right-[-120px] xl:right-0">
      <div className="h-[280px]">
        <Image
          src={rightSection}
          alt="Right Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto"
          priority
        />
      </div>
    </div>
    {/* Left Mobile */}
    <div className="absolute bottom-0 left-[-25px] xxs:left-0 md:hidden">
      <div className="h-[280px]">
        <Image
          src={leftSectionMobile}
          alt="Left Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto object-cover"
          priority
        />
      </div>
    </div>
    {/* Right Mobile */}
    <div className="absolute bottom-0 right-[-25px] xxs:right-0 md:hidden">
      <div className="h-[280px]">
        <Image
          src={rightSectionMobile}
          alt="Right Section"
          loading="eager"
          height={800}
          width={800}
          className="h-full w-auto"
          priority
        />
      </div>
    </div>
    <div className="relative">
      <div className="reebelo-container">
        <div className="flex flex-col items-center justify-center">
          <h1 className="mt-1.5 text-center text-xl font-bold leading-tight xxs:text-2xl md:text-3xl">
            {t`Boxing Day Deals`}
          </h1>
          <p className="text-center text-sm font-light md:text-base">
            {t`Refurbished Favorites Up To 70% Off`}
          </p>
          <div className="mt-3 flex items-center justify-center rounded-full border-2 border-gray-700 !bg-[#DA5451] px-5 py-2 text-xs font-semibold text-white">
            {t`Shop Deals`}
          </div>
        </div>
      </div>
    </div>
  </Link>
);

export default BoxingDayHero;
